/**
 * Definition of our vue.js routes
 */

import _ from 'lodash'
import Vue from 'vue'
import VueRouter from 'vue-router'
import AppLayout from './components/layouts/App'
import AuthLayout from './components/layouts/Auth'
import HomeLayout from './components/layouts/Home'
import SubjectShelf from './components/subject-shelf/SubjectShelf'
import FileImporter from './components/file-importer/FileImporter'
import FileExporter from './components/file-exporter/FileExporter'
import FileProcessing from './components/file-importer/FileProcessing'
import MicroNoteImportSuccess from './components/file-importer/MicroNoteImportSuccess'

import HomePage from './components/home/HomePage'
import FeaturesPage from './components/home/FeaturesPage'
import AboutUsPage from './components/home/AboutUsPage'
import ContactUsPage from './components/home/ContactUsPage'
import FeedbackFormPage from './components/home/FeedbackFormPage'
import AdvertisePage from './components/home/AdvertisePage'
import BlogPage from './components/home/BlogPage'
import BlogArticlePage from './components/home/BlogArticlePage'
import TermsConditionsPage from './components/home/TermsConditionsPage'
import PrivacyPolicyPage from './components/home/PrivacyPolicyPage'

import MicroNoteEditor from './components/micro-note-editor/MicroNoteEditor'
import MicroNoteCreator from './components/micro-note-editor/MicroNoteCreator'
import MicroNoteList from './components/micro-note-list/MicroNoteList'
import LectureNoteEditor from './components/lecture-note-editor/LectureNoteEditor'
import LectureNoteList from './components/lecture-note-list/LectureNoteList'
import ChapterStudier from './components/chapter-studier/ChapterStudier'
import ChapterSharer from './components/chapter-sharer/ChapterSharer'
import ReceiveChapter from './components/chapter-sharer/ReceiveChapter'

import Settings from './components/user/settings'
import Account from './components/user/account'

import AdManager from './components/admin/ad/admanager'
import BlogManager from './components/admin/blog/blogmanager'
import BlogPostEdit from './components/admin/blog/posteditor'
import UserManager from './components/admin/users/usermanager'
import UserActivityReport from './components/admin/users/useractivityreport'

import Signup from './components/signup/Signup'
import SignupSuccess from './components/signup/Success'
import Login from './components/login/Login'
import ForgotPassword from './components/login/ForgotPassword'
import ResetPassword from './components/login/ResetPassword'
import NewsletterSubscribe from './components/newsletter/Subscribe'
//import NewsletterUnSubscribe from './components/newsletter/UnSubscribe'

import store from './store'
import { SET_PAGE_TITLE, SET_AD_AREA, SET_PAGE_DESCRIPTION, SET_PAGE_KEYWORDS } from './store/mutation-types'

import NotFound from './components/NotFound'

// Temp
import TempHomeLayout from './components/temp/layouts/Home'
import TempHomePage from './components/temp/home/HomePage'
import TempFeaturesPage from './components/temp/home/FeaturesPage'
import TempAboutUsPage from './components/temp/home/AboutUsPage'
import TempContactUsPage from './components/temp/home/ContactUsPage'
import TempFeedbackFormPage from './components/temp/home/FeedbackFormPage'
import TempAdvertisePage from './components/temp/home/AdvertisePage'
import TempBlogPage from './components/temp/home/BlogPage'
import TempBlogArticlePage from './components/temp/home/BlogArticlePage'
import TempSignup from './components/temp/signup/Signup'
import TempSignupSuccess from './components/temp/signup/Success'
import TempLogin from './components/temp/login/Login'
import TempForgotPassword from './components/temp/login/ForgotPassword'
import TempResetPassword from './components/temp/login/ResetPassword'


Vue.use(VueRouter)

// Add meta.auth = true to password protect a route
const routes = [
  // Home-related
  {
    path: '/',
    component: HomeLayout,
    children: [
      // Homepage

      // NOTE: When adding new routes that should be indexed by google, add to static/sitemap.xml too.

      { name: 'home-page', path: '/', component: HomePage, meta: { title: 'Contextual Learning Experience', auth: false, sidebar: false, publicNav: true, description: 'CLEX helps improve grades by organizing notes to prioritize and focus studying. This simple, easy-to-use software provides a flexible approach to learning', keywords: '' } },
      { name: 'features', path: '/features', component: FeaturesPage, meta: { title: 'Features', auth: false, sidebar: false, publicNav: true, adArea: 'public', description: 'We believe learning should be an engaging and rewarding experience. CLEX is designed with your brain in mind.' } },
      { name: 'about-us', path: '/about-us', component: AboutUsPage, meta: { title: 'About CLEX', auth: false, sidebar: false, publicNav: true, description: 'We\'re an educational company offering study tools for students in university, collage, high school, and skilled training centers.' } },
      { name: 'contact-us', path: '/contact-us', component: ContactUsPage, meta: { title: 'Contact us', auth: false, sidebar: false, publicNav: true, adArea: 'public', description: 'Questions about how CLEX works? Send us an email and we\'ll get back to you as soon as possible.' } },
      { name: 'feedback-form', path: '/feedback-form', component: FeedbackFormPage, meta: { title: 'Feedback form', auth: false, sidebar: false, publicNav: true, adArea: 'public', description: 'We would love to hear about your experiences while studying with CLEX. Please get in touch and tell us how we\'re doing' } },
      { name: 'advertise', path: '/advertise', component: AdvertisePage, meta: { title: 'Advertise', auth: false, sidebar: false, publicNav: true, description: 'Interested in advertising your products or service to our community of students? Get in touch for more information.' } },
      { name: 'blog', path: '/blog', component: BlogPage, meta: { title: 'CLEX Blog', auth: false, sidebar: false, publicNav: true, adArea: 'public', description: 'Read the latest articles from the CLEX blog and stay up-to-date with the best studying methods and learning techniques' } },
      { name: 'blog-article', path: '/blog/article/:id', component: BlogArticlePage, meta: { title: 'Blog Article', auth: false, sidebar: false, publicNav: true, adArea: 'public' } },
      { name: 'signup-success', path: '/signup-success', component: SignupSuccess, meta: { title: 'Signup Success', publicNav: true, description: '' } },
      //{ name: 'terms-conditions', path: '/terms-and-conditions', component: TermsConditionsPage, meta: { title: 'Terms and Conditions', auth: false, sidebar: false, publicNav: true, adArea: 'public' } },
      //{ name: 'privacy-policy', path: '/privacy-policy', component: PrivacyPolicyPage, meta: { title: 'Privacy Policy', auth: false, sidebar: false, publicNav: true, adArea: 'public' } },
      { name: 'signup', path: '/signup', component: Signup, meta: { title: 'Signup', publicNav: true, description: 'Create a CLEX account to join our community of students. Store your lecture notes in one place and streamline your studies' } },
      { name: 'login', path: '/login', component: Login, meta: { title: 'Login', publicNav: true, description: 'Login to your CLEX account to start importing your lecture notes. Study your subjects in a way that suits you.' } },
      { name: 'forgot-password', path: '/forgot-password', component: ForgotPassword, meta: { title: 'Forgot Password', publicNav: true } },
      { name: 'reset-password', path: '/reset-password', component: ResetPassword, meta: { title: 'Reset Password', publicNav: true } },
      { name: 'newsletter-subscribe', path: '/newsletter-subscribe', component: NewsletterSubscribe, meta: { title: 'Newsletter Signup', publicNav: true, description: 'Joing the CLEX mailing list for exclusive offers and the latest news.' } },
      //{ name: 'newsletter-unsubscribe', path: '/newsletter-unsubscribe', component: NewsletterUnSubscribe, meta: { title: 'Newsletter Unsubscribe', publicNav: true } },
    ],
  },
  //{
  //  path: '/temp',
  //  component: TempHomeLayout,
  //  meta: { auth: true, admin:true },
  //  children: [
  //    // Homepage

  //    // NOTE: When adding new routes that should be indexed by google, add to static/sitemap.xml too.

  //    { name: 'home-page-temp', path: '/temp/', component: TempHomePage, meta: { title: 'Contextual Learning Experience', auth: true, admin: true, sidebar: false, publicNav: true, description: 'CLEX helps improve grades by organizing notes to prioritize and focus studying. This simple, easy-to-use software provides a flexible approach to learning', keywords: '' } },
  //    { name: 'features-temp', path: '/temp/features', component: TempFeaturesPage, meta: { title: 'Features', auth: true, admin: true, sidebar: false, publicNav: true, adArea: 'public', description: 'We believe learning should be an engaging and rewarding experience. CLEX is designed with your brain in mind.' } },
  //    { name: 'about-us-temp', path: '/temp/about-us', component: TempAboutUsPage, meta: { title: 'About CLEX', auth: true, admin: true, sidebar: false, publicNav: true, adArea: 'public', description: 'We\'re an educational company offering study tools for students in university, collage, high school, and skilled training centers.' } },
  //    { name: 'contact-us-temp', path: '/temp/contact-us', component: TempContactUsPage, meta: { title: 'Contact us', auth: true, admin: true, sidebar: false, publicNav: true, adArea: 'public', description: 'Questions about how CLEX works? Send us an email and we\'ll get back to you as soon as possible.' } },
  //    { name: 'feedback-form-temp', path: '/temp/feedback-form', component: TempFeedbackFormPage, meta: { title: 'Feedback form', auth: true, admin: true, sidebar: false, publicNav: true, adArea: 'public', description: 'We would love to hear about your experiences while studying with CLEX. Please get in touch and tell us how we\'re doing' } },
  //    { name: 'advertise-temp', path: '/temp/advertise', component: TempAdvertisePage, meta: { title: 'Advertise', auth: true, admin: true, sidebar: false, publicNav: true, description: 'Interested in advertising your products or service to our community of students? Get in touch for more information.' } },
  //    { name: 'blog-temp', path: '/temp/blog', component: TempBlogPage, meta: { title: 'CLEX Blog', auth: true, admin: true, sidebar: false, publicNav: true, adArea: 'public', description: 'Read the latest articles from the CLEX blog and stay up-to-date with the best studying methods and learning techniques' } },
  //    { name: 'blog-article-temp', path: '/temp/blog/article/:id', component: TempBlogArticlePage, meta: { title: 'Blog Article', auth: true, admin: true, sidebar: false, publicNav: true, adArea: 'public' } },
  //    { name: 'signup-success-temp', path: '/temp/signup-success', component: TempSignupSuccess, meta: { title: 'Signup Success', publicNav: true, description: '', auth: true, admin: true } },
  //    { name: 'signup-temp', path: '/temp/signup', component: TempSignup, meta: { title: 'Signup', publicNav: true, description: 'Create a CLEX account to join our community of students. Store your lecture notes in one place and streamline your studies' } },
  //    { name: 'login-temp', path: '/temp/login', component: TempLogin, meta: { title: 'Login', publicNav: true, description: 'Login to your CLEX account to start importing your lecture notes. Study your subjects in a way that suits you.' } },
  //    { name: 'forgot-password-temp', path: '/temp/forgot-password', component: TempForgotPassword, meta: { title: 'Forgot Password', publicNav: true } },
  //    { name: 'reset-password-temp', path: '/temp/reset-password', component: TempResetPassword, meta: { title: 'Reset Password', publicNav: true } },
  //  ],
  //},

  {
    path: '/',
    component: AppLayout,
    meta: {auth: true},
    children: [
      { name: 'importer', path: 'import', component: FileImporter, meta: { title: 'Import Lecture Notes', auth: true, adArea: 'dashboard' } },
      { name: 'processing', path: 'processing/:id', component: FileProcessing, meta: { title: 'Processing Lecture Notes', auth: true, adArea: 'dashboard' } },
      { name: 'exporter', path: 'export', component: FileExporter, meta: { title: 'Export Lecture Notes', auth: true, adArea: 'dashboard' } },
      { name: 'micronote-import-success', path: 'micronote-import-success', component: MicroNoteImportSuccess, meta: { title: 'MicroNotes imported', auth: true, adArea: 'dashboard' } },
      { name: 'share-chapter', path: 'share-chapter', component: ChapterSharer, meta: { title: 'Share chapter', auth: true, adArea: 'dashboard' } },
      { name: 'receive-chapter', path: 'receive-chapter', component: ReceiveChapter, meta: { title: 'Receive study notes', auth: true, adArea: 'dashboard' } },

      { name: 'subject-shelf', path: 'subject-shelf', component: SubjectShelf, meta: { title: 'Subject Shelf', auth: true, adArea: 'dashboard'} },

      // Lecture notes
      { name: 'lecture-notes', path: '/lecture-notes', component: LectureNoteList, meta: { title: 'My Lecture Notes', auth: true, adArea: 'dashboard'} },
      { name: 'lecture-note-editor', path: '/lecture-notes/:id/edit', component: LectureNoteEditor, meta: { title: 'Lecture Note Editor', auth: true, adArea: 'dashboard', sidebar: false} },

      // Micro notes
      { name: 'micro-notes', path: '/chapters/:chapterId/micro-notes', component: MicroNoteList, meta: { title: 'Micro Notes', auth: true, adArea: 'dashboard'} },
      { name: 'micro-note-editor', path: '/chapters/:chapterId/micro-notes/edit', component: MicroNoteEditor, meta: { title: 'Edit Micro Note', auth: true, sidebar: false, adArea: 'studier' } },
      { name: 'micro-note-creator', path: '/chapters/:chapterId/micro-notes/create', component: MicroNoteCreator, meta: { title: 'Create Micro Notes', auth: true, sidebar: false, adArea: 'studier' } },

      // Study mode
      // "In the Subject Shelf (main menu) when a user selects a chapter they can then go into study mode. This is were the student studies micro-notes one at a time, then decides how hard it was to recall the information and sets the “next study time” accordingly"
      { name: 'chapter-studier', path: '/chapters/:chapterId/study', component: ChapterStudier, meta: { title: 'Chapter Studier', auth: true, sidebar: false, adArea: 'studier' } },

      // user
      { name: 'user-settings', path: '/user/settings', component: Settings, meta: { title: 'Settings', auth: true, adArea: 'dashboard' } },
      { name: 'user-account', path: '/user/account', component: Account, meta: { title: 'Account', auth: true, adArea: 'dashboard' } },

      // admin
      { name: 'ad-manager', path: '/admin/ad-manager', component: AdManager, meta: { title: 'Ad Manager', auth: true, sidebar: true, admin: true } },
      { name: 'blog-manager', path: '/admin/blog-manager', component: BlogManager, meta: { title: 'Blog Post Manager', auth: true, sidebar: true, admin: true } },
      { name: 'blog-post-edit', path: '/admin/blog-manager/edit/:id?', component: BlogPostEdit, meta: { title: 'Edit Blog Post', auth: true, sidebar: true, admin: true } },
      { name: 'user-manager', path: '/admin/user-manager', component: UserManager, meta: { title: 'User Manager', auth: true, sidebar: true, admin: true } },
      { name: 'user-activity-report', path: '/admin/user-activity-report', component: UserActivityReport, meta: { title: 'User Activity Report', auth: true, sidebar: true, admin: true } },
    ],
  },

  // 404 catch-all
  { path: '*', component: NotFound, meta: { title: 'Page Not Found' } }
]

const router = new VueRouter({
  mode: 'history',
  routes, // short for routes: routes
  linkActiveClass: 'active',
})


// Scroll to top of page on route change
router.afterEach((to, from) => {
  window.scrollTo(0, 0);
})


/**
 * Redirected unauthenticated users to login page
 */

router.beforeEach((to, from, next) => {
  let loggedIn = store.state.currentUser.loggedIn;

  // check if this is an admin page
  if (to.meta.admin && store.state.currentUser.role !== 'admin' && from && from.name) next('/page-not-found');

  if (to.name === 'login') return next();
  if ((loggedIn || !to.meta.auth) && from && from.name) return next();
  
  // -- Page is protected and user is not logged in --
  // OR
  // -- This is the first page load (no FROM record) --

  if(localStorage.getItem('access-token')) {
    // This may be the first load, let's validate this token
    store.dispatch('validateToken').then(() => {
      // Token is valid
      // console.log('Valid!');
      next();
    }, () => {
      // Token is invalid
      console.log('Error: Invalid token');
      next('/login')
    });
  } else {
    if (to.meta.auth) {
      next('/login')
    } else {
      return next();
    }
  }
})

// Page - page title middleware
router.beforeEach((to, from, next) => {
  store.commit(SET_PAGE_TITLE, { title: to.meta.title })
  store.commit(SET_PAGE_DESCRIPTION, { description: to.meta.description })
  store.commit(SET_PAGE_KEYWORDS, { keywords: to.meta.keywords })
  next();
})

// Page - page ad display middleware
router.beforeEach((to, from, next) => {
  const adArea = _.isUndefined(to.meta.adArea) ? '' : to.meta.adArea;

  store.commit(SET_AD_AREA, { adArea: adArea });
  next();
})

// Page - sidebar state middleware
router.beforeEach((to, from, next) => {
  const sidebarOpen = _.isUndefined(to.meta.sidebar) ? true : to.meta.sidebar;
  if(sidebarOpen) {
    store.commit('OPEN_SIDEBAR')
  } else {
    store.commit('CLOSE_SIDEBAR')
  }

  const publicNav = _.isUndefined(to.meta.publicNav) ? false : to.meta.publicNav;
  if (publicNav) {
    store.commit('SHOW_PUBLIC_ELEMS')
  } else {
    store.commit('HIDE_PUBLIC_ELEMS')
  }

  next();
})


export default router



// WEBPACK FOOTER //
// ./src/router.js